import * as yup from 'yup';

export const RelativeContactDataSchema = yup.object({
  lastName: yup.string().required(),
  firstName: yup.string().required(),
  company: yup.string().notRequired().nullable(),
  street: yup.string().notRequired().nullable(),
  number: yup.string().notRequired().nullable(),
  zipCode: yup.string().notRequired().nullable(),
  city: yup.string().notRequired().nullable(),
  phone: yup.string().notRequired().nullable(),
  mobilePhone: yup.string().notRequired().nullable(),
  email: yup.string().notRequired().nullable(),
});

export interface IRelativeContactData {
  lastName: string;
  firstName: string;
  company?: string;
  street?: string;
  number?: string;
  zipCode?: string;
  city?: string;
  phone?: string;
  mobilePhone?: string;
  email?: string;
}

export const CreateRelativeContactDataSchema = yup
  .object({
    residentId: yup.string().required(),
  })
  .concat(RelativeContactDataSchema);

export interface ICreateRelativeContactData extends IRelativeContactData {
  residentId: string;
}

export const UpdateRelativeContactDataSchema = yup
  .object({
    id: yup.string().required(),
  })
  .concat(RelativeContactDataSchema);

export interface IUpdateRelativeContactData {
  id: string;
}
